import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import Column from '../../../../components/Column';
import AccountActivityLimitsPanel from '../campaigns/AccountActivityLimitsPanel';

const AccountActivity: FunctionComponent = () => (
  <Wrap>
    <Column gap="32px">
      <AccountActivityLimitsPanel />
    </Column>
  </Wrap>
);

const Wrap = styled.div`
  width: 100%;
`;

export default AccountActivity;
